import * as React from "react";
import { cx } from "utils/join-classnames";
import { Icon } from "ui/components";
import styles from "./FileInput.module.scss";

type Props = {
    value: string;
    theme: string;
    defaultText: string;
    onValueChanged(value: File): void;
    id?: string;
    valid?: boolean;
    disabled?: boolean;
};

const FileInput: React.FC<Props> = ({
    value,
    theme,
    defaultText,
    onValueChanged,
    id,
    valid,
    disabled,
}) => {
    const hiddenFileInputRef = React.useRef<HTMLInputElement>(null);
    const handleInputClick = () => {
        if (!hiddenFileInputRef.current) {
            return;
        }
        hiddenFileInputRef.current.click();
    };
    return (
        <div className={styles.input__container}>
            <input
                type="file"
                ref={hiddenFileInputRef}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.files && "length" in e.target.files) {
                        onValueChanged(e.target.files[0]);
                    }
                }}
                className={styles.hidden}
                disabled={disabled}
            />
            <input
                type="text"
                className={cx(
                    styles.input,
                    theme === "dark" ? styles.input__dark : styles.input__light,
                    !valid && valid !== undefined && styles.input__invalid,
                )}
                value={value}
                placeholder={defaultText}
                id={id}
                disabled={disabled}
                onClick={handleInputClick}
                readOnly
            />
            <Icon name="file" className={styles.input__icon} />
        </div>
    );
};

export default FileInput;
